import { getField, updateField } from 'vuex-map-fields'
import { IAG_CUSTOMER_URL } from '~/assets/variables/endpoints'

export const state = () => ({
  permissions: [],
  canSearchContactAssociation: true,
})

export const getters = {
  getField,
}

export const actions = {
  getPermissions({ commit, state }, params) {
    return this.$axios.get(`${IAG_CUSTOMER_URL}/permissions/me`).then((res) => {
      const permissions = res.data?.data?.[0]?.permissions || []
      commit('SET_PERMISSIONS', permissions)
      const customerAssocPermission = state.permissions.find(
        (permission) => permission.name === 'customers_customers_searchassoc'
      )
      if (customerAssocPermission) {
        commit(
          'UPDATE_CONTACT_ASSOCIATION_PERMISSION',
          customerAssocPermission?.is_enabled ?? true
        )
      }
      return res.data
    })
  },
}

export const mutations = {
  updateField,
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
  UPDATE_CONTACT_ASSOCIATION_PERMISSION(state, value) {
    state.canSearchContactAssociation = value
  },
}
